import { useContext, useEffect } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useListAction from "../actions/list/useListAction";
import useDetailsAction from "../actions/details/useDetailsAction";
import { Card } from "react-bootstrap";
import { ListActionContext } from "../actions/list/ListActionContext";

function PagesPage(props: any) {
  const { filters, formDefaultValues, formFilterValues, config } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    detailsFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);


  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */

  let tableConfig = getConfig({
    initializeFunction, // We pass the function to initialize a new element (used in the create button)
    indexFunction, // We pass the function to index the table
    detailsFunction, // We pass the function to get an element (used in the edit button)
    prepareRemoveFunction,
    config
    /**newActionsTableConfig**/
  });
  setTableConfig(tableConfig);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t(config.title ? config.title : "pages")}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default PagesPage;
